import React from 'react';
import { FetchTechWritersState, FetchBarRaisersState } from '../components/content/table/Hooks';
import UserProfile from '../model/UserProfile';

/**
 * @deprecated Legacy context. Do not use in new code.
 * Define a new context in `/src/contexts/` following the `use*` hook pattern.
 */
const WorkflowTableContext = React.createContext<WorkflowTableContextData>({});

/**
 * @deprecated Legacy context. Do not use in new code.
 * Define a new context in `/src/contexts/` following the `use*` hook pattern.
 */
interface WorkflowTableContextData {
  fetchTechWritersState?: FetchTechWritersState;
  fetchBarRaisersState?: FetchBarRaisersState;
}

/**
 * @deprecated Legacy context. Do not use in new code.
 * Define a new context in `/src/contexts/` following the `use*` hook pattern.
 */
interface WorkflowTableContextProps {
  workflowTableContextData: WorkflowTableContextData;
}

export { WorkflowTableContext };
export type { WorkflowTableContextData, WorkflowTableContextProps };
